export const UPDATE = 'timeOfDay/update';
